import { flexRender, type Row } from '@tanstack/react-table';
import { type AppTableFeatures } from '../react-table-features';

import { TableCell } from '../table-cell/TableCell';
import type { RevampTableRow } from './RevampTable.types';
import {
  getRevampTableCellAlignment,
  isNumericColumnType,
  isRevampTableColumn,
} from './utils';

interface RevampTableBodyRowProps {
  row: Row<AppTableFeatures, RevampTableRow>;
  onRowClick?: (row: Row<AppTableFeatures, RevampTableRow>) => void;
}

export const RevampTableBodyRow = ({
  row,
  onRowClick,
}: RevampTableBodyRowProps) => (
  <tr onClick={onRowClick ? () => onRowClick(row) : undefined}>
    {row.getVisibleCells().map(cell => {
      const meta = cell.column.columnDef.meta;
      const column = isRevampTableColumn(meta) ? meta : undefined;

      return (
        <TableCell
          key={cell.id}
          alignment={column ? getRevampTableCellAlignment(column) : undefined}
          isNumber={
            !!column && (column.isNumber ?? isNumericColumnType(column.type))
          }
        >
          {flexRender(cell.column.columnDef.cell, cell.getContext())}
        </TableCell>
      );
    })}
  </tr>
);
